import type * as SchemaTypes from '../../../apolloClient.types';

import type { SubgroupListItemDataFragment } from '../GroupListing/GroupList.api';
import { gql } from '@apollo/client';
import { SubgroupListItemDataFragmentDoc } from '../GroupListing/GroupList.api';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UpdateSubgroupMutationVariables = SchemaTypes.Exact<{
  id: SchemaTypes.Scalars['ObjectID']['input'];
  input: SchemaTypes.UpdateSubgroupInput;
}>;


export type UpdateSubgroupMutation = (
  { __typename: 'Mutation' }
  & { updateSubgroup: (
    { __typename: 'ErrorResponse' }
    & { fields?: SchemaTypes.Maybe<Array<(
      { __typename: 'ErrorOnField' }
      & Pick<SchemaTypes.ErrorOnField, 'field' | 'message'>
    )>> }
  ) | (
    { __typename: 'UpdateSubgroupSuccessfulResponse' }
    & { result: (
      { __typename: 'Subgroup' }
      & SubgroupListItemDataFragment
    ) }
  ) }
);


export const UpdateSubgroupDocument = /*#__PURE__*/ gql`
    mutation UpdateSubgroup($id: ObjectID!, $input: UpdateSubgroupInput!) {
  updateSubgroup(id: $id, input: $input) {
    __typename
    ... on UpdateSubgroupSuccessfulResponse {
      result {
        ...SubgroupListItemData
      }
    }
    ... on ErrorResponse {
      fields {
        field
        message
      }
    }
  }
}
    ${SubgroupListItemDataFragmentDoc}`;
export type UpdateSubgroupMutationFn = Apollo.MutationFunction<UpdateSubgroupMutation, UpdateSubgroupMutationVariables>;

/**
 * __useUpdateSubgroupMutation__
 *
 * To run a mutation, you first call `useUpdateSubgroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSubgroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSubgroupMutation, { data, loading, error }] = useUpdateSubgroupMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSubgroupMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSubgroupMutation, UpdateSubgroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSubgroupMutation, UpdateSubgroupMutationVariables>(UpdateSubgroupDocument, options);
      }
export type UpdateSubgroupMutationHookResult = ReturnType<typeof useUpdateSubgroupMutation>;
export type UpdateSubgroupMutationResult = Apollo.MutationResult<UpdateSubgroupMutation>;
export type UpdateSubgroupMutationOptions = Apollo.BaseMutationOptions<UpdateSubgroupMutation, UpdateSubgroupMutationVariables>;